import { Inline } from "PFComponents/containers";
import { ReadOnlyField } from "PFComponents/read_only_field";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { PostUntilChangeReason } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./expiry_date.module.scss";

type ExpiryDateReadOnlyProps = {
  postUntil: string;
  reason: PostUntilChangeReason | null;
};

export const ExpiryDateReadOnly = ({ postUntil, reason }: ExpiryDateReadOnlyProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections.basicInformation.expiryDate" });
  const { formatDate } = useDateFormatter();

  return (
    <Inline gap="spacingLg">
      <ReadOnlyField
        label={t("title")}
        required
        value={formatDate(postUntil)}
        classes={{ root: css.readOnlyDate }}
      />
      {reason && <ReadOnlyField label={t("reasonToChange")} value={reason.text ?? ""} />}
    </Inline>
  );
};
